import React from "react";
import { Helmet } from "react-helmet-async";

const StructuredData = () => {
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "Person",
    name: "Mihir Shah",
    alternateName: "Mihir Shah",
    url: "https://mihirshah.tech",
    image: "https://mihirshah.tech/profile.jpg",
    sameAs: [
      "https://github.com/mihir-shah99",
      "https://linkedin.com/in/mihir-shah99",
      "https://x.com/mihirshah99",
    ],
    jobTitle: ["OWASP VXDF Project Leader", "Security Engineer", "Author"],
    worksFor: {
      "@type": "Organization",
      name: "OWASP",
      url: "https://owasp.org",
    },
    alumniOf: {
      "@type": "CollegeOrUniversity",
      name: "Stanford University",
    },
    knowsAbout: [
      "Cloud Security",
      "Application Security",
      "DevSecOps",
      "OWASP VXDF",
      "Validated Exploitable Data Flow",
      "Kubernetes Security",
      "Container Security",
      "Security Architecture",
    ],
    memberOf: [
      {
        "@type": "Organization",
        name: "OWASP",
        url: "https://owasp.org",
      },
    ],
    author: {
      "@type": "Book",
      name: "Cloud Native Software Security Handbook",
      publisher: "Packt Publishing",
      datePublished: "2023",
    },
  };

  const organizationData = {
    "@context": "https://schema.org",
    "@type": "Project",
    name: "OWASP VXDF (Validated Exploitable Data Flow)",
    alternateName: "VXDF",
    url: "https://vxdf.org",
    description:
      "A comprehensive framework for managing and validating exploitable vulnerability data flows in modern software systems.",
    creator: {
      "@type": "Person",
      name: "Mihir Shah",
      url: "https://mihirshah.tech",
    },
    maintainer: {
      "@type": "Person",
      name: "Mihir Shah",
      url: "https://mihirshah.tech",
    },
    parentOrganization: {
      "@type": "Organization",
      name: "OWASP",
      url: "https://owasp.org",
    },
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(structuredData)}
      </script>
      <script type="application/ld+json">
        {JSON.stringify(organizationData)}
      </script>
    </Helmet>
  );
};

export default StructuredData;
